var $eab312ee632ab3b3$exports = {};
// Google
const $eab312ee632ab3b3$var$gtagScript = document.createElement("script");
$eab312ee632ab3b3$var$gtagScript.type = "text/javascript";
$eab312ee632ab3b3$var$gtagScript.setAttribute("async", "true");
$eab312ee632ab3b3$var$gtagScript.setAttribute("src", "https://www.googletagmanager.com/gtag/js");
document.head.appendChild($eab312ee632ab3b3$var$gtagScript);
window.dataLayer = window.dataLayer || [];
function $eab312ee632ab3b3$var$gtag() {
    dataLayer.push(arguments);
}
window.gtag = $eab312ee632ab3b3$var$gtag;
$eab312ee632ab3b3$var$gtag("js", new Date());
$eab312ee632ab3b3$var$gtag("config", "G-DBV9KL7MSE", {
    debug_mode: false
});
$eab312ee632ab3b3$var$gtag("config", "AW-11105043900", {
    debug_mode: false,
    groups: "ads"
});
!function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
}(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
fbq("init", "722343942682414");
fbq("track", "PageView");


//# sourceMappingURL=index.c508ff97.js.map
